<template>
  <div>
    <p
      v-if="introText"
      class="mb-0"
      v-html="introText.replace(/\\n/g, '<br>')"
    ></p>
    <v-checkbox
      :model-value="modelValue"
      @update:model-value="$emit('update:modelValue', $event)"
      :true-value="1"
      :false-value="0"
      :id="checkboxId"
      density="compact"
      style="--v-icon-size: 12px; --v-selection-control-size: 12px"
      hide-details
      :disabled="disabled"
      :class="[noCheckIconClass, extraClass]"
    >
      <template v-slot:label>
        <div>
          <template v-for="(part, index) in parsedDescription" :key="index">
            <span
              v-if="part === '{{term}}'"
              class="text-underline"
              @click.prevent="openTerm"
              :data-test="
                dataTestPrefix ? `${dataTestPrefix}-terms-btn` : undefined
              "
            >
              {{ loginType == 2 ? $t("term_email") : $t("term") }}
            </span>
            <span
              v-else-if="part === '{{policy}}'"
              class="text-underline"
              @click.prevent="openPolicy"
              :data-test="
                dataTestPrefix ? `${dataTestPrefix}-policy-btn` : undefined
              "
            >
              {{ loginType == 2 ? $t("policy_email") : $t("policy") }}
            </span>
            <template v-else><span v-html="part"></span></template>
          </template>
          <span v-if="required && !$isShowTab" class="text-consent-danger"
            >&nbsp;*</span
          >
          <span v-if="$isShowTab && showTabRequired" class="text-danger"
            >&nbsp;*</span
          >
        </div>
      </template>
    </v-checkbox>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicyCheckbox",
  props: {
    modelValue: { required: true },
    type: { required: false, type: String, default: null },
    dataTestPrefix: { required: false, type: String, default: "" },
    description: { required: false, type: String, default: "" },
    loginType: { required: false, default: 1 },
    checkboxId: { required: false, type: String, default: "" },
    disabled: { required: false, type: Boolean, default: false },
    required: { required: false, type: Boolean, default: false },
    showTabRequired: { required: false, type: Boolean, default: false },
    extraClass: { required: false, type: String, default: "" }
  },
  emits: ["update:modelValue"],
  computed: {
    isMinimalLayout() {
      return (
        this.lineLayout == "Minimal" ||
        this.$isMinimalMinibar ||
        this.$isMinimalProfile ||
        this.$isCleanLayout
      );
    },

    privacyPolicyDescription() {
      return this.loginType == 2
        ? this.$t("consent_policy_message_email_login_pdpa_email")
        : this.$t("consent_policy_message");
    },
    consentTermDescription() {
      return this.loginType == 2
        ? this.$t("consent_term_message_email_login_policy_email")
        : this.$t("consent_term_message");
    },
    orlebaBrownConsentDescription() {
      return `I consent to Orlebar Brown Thailand sharing my personal data with Orlebar Brown Limited, for its services and benefits (such as its worldwide promise/guarantee) and for direct marketing by Orlebar Brown Limited, according to their {{term}}.\n\nI consent to Orlebar Brown Thailand sharing my personal data with its related group of companies, for the purpose of direct marketing by them for other offerings in Thailand, according to the {{policy}}`;
    },
    resolvedDescription() {
      if (this.type === "policy") {
        return this.privacyPolicyDescription;
      }
      if (this.type === "term") {
        return this.consentTermDescription;
      }
      return this.description;
    },
    parsedDescription() {
      return this.resolvedDescription.split(/(\{\{.*?\}\})/g).filter(Boolean);
    },
    introText() {
      if (this.type === "policy") {
        return this.loginType == 2
          ? this.$t("consent_email_policy_intro")
          : this.$t("consent_policy_intro");
      }
      if (this.type === "term") {
        return this.loginType == 2
          ? this.$t("consent_email_term_intro")
          : this.$t("consent_term_intro");
      }
      return null;
    },
    noCheckIconClass() {
      return this.$isCleanLayout ||
        this.$isShowTab ||
        this.$isMinimalMinibar ||
        (this.$isMinimalCompact && !this.$config.isMinimalSharp) ||
        this.$isMinimalProfileBanner
        ? "no-check-icon"
        : "";
    }
  },
  methods: {
    openPolicy() {
      if (this.$store.state.theme.is_custom_privacy_link == "1")
        return window.open(this.$store.state.theme.consent_url_link, "_blank");
      this.emitter.emit("showModal", "policy");
    },
    openTerm() {
      if (this.$store.state.theme.is_term_and_con_url == "1")
        return window.open(this.$store.state.theme.term_and_con_url, "_blank");
      this.emitter.emit("showModal", "term");
    }
  }
};
</script>

<style lang="scss" scoped>
.text-underline {
  text-decoration: underline;
}
</style>
